import { useInitializeIntl } from "@/infra/locale";

export function useInitializeApp() {
  useInitializeIntl();
}
